type DeliveryStatus = { label: string; tone: 'ok' | 'bad' | 'warn' | 'paused' };
export function deliveryStatus(operation?: string, secondary?: string | null): DeliveryStatus {
  const status = (secondary || '').toUpperCase();
  if (/REJECT|AUDIT_DENY/.test(status)) return { label: 'Rejected', tone: 'bad' };
  if (status.includes('DELETE')) return { label: 'Deleted', tone: 'bad' };
  // An enabled child cannot deliver while its parent is disabled.
  if (/DISABLE|PAUSED/.test(status) || operation !== 'ENABLE') return { label: 'Paused', tone: 'paused' };
  if (/REVIEW|AUDIT/.test(status)) return { label: 'In review', tone: 'warn' };
  if (/NOT_DELIVER|BUDGET|BALANCE|LIMIT|FROZEN/.test(status)) return { label: 'Not delivering', tone: 'warn' };
  return { label: 'Enabled', tone: 'ok' };
}
